import styles from 'styles/views/EventEditor.css';
import React, { Component, PropTypes } from 'react';
import _ from '../utils/lodash';
import { MODE } from 'constants/mode';
import { prettifyNumber } from 'utils/number';
import contextService from 'services/contextService';
import eventGroupSvc from 'services/eventGroupService';
import Event, {SELECTION_TYPE} from 'model/Event';
import {HEADER_HEIGHT} from 'main';
import { PAGE_TYPE } from 'views/App';
import Popup from 'views/widgets/Popup';
import ChartContainer from 'views/widgets/ChartContainer';
import EventInsight from 'views/widgets/EventInsight';
import Button from 'views/widgets/Button';
import CheckBox from 'views/widgets/Input/CheckBox';
import InputText from 'views/widgets/Input/InputText';
import PageSelection from 'views/PageSelection/PageSelection';
import Loader from 'views/BaseElements/Loader/Loader';
import CssSelectorEditor from 'views/widgets/cssSelectorEditor/CssSelectorEditor';
import { beautifyPageviewOperators } from 'utils/operatorPurge';
import configSvc from 'services/configService';
import { wrapFocusIn } from 'views/shared/utils/focusHandler';
import classNames from '../../node_modules/classnames/index';
import TabBar from './BaseElements/TabBar/TabBar';

const EVENT_NAME_MAX_LENGTH = 64;

const defaultStats = {
  events: [
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 },
    { day: '', clicks: 0 }
  ],
  total: {
    clicks: 0,
    users: 0
  }
};

const defaultState = {
  errorMsg: '',
  scroll: false,
  stats: defaultStats,
  loading: false,
  validating: false,
  changed: false,
  input: null
};

export default class EventEditor extends Component {
  static propTypes = {
    editorState: PropTypes.object,
    event: PropTypes.oneOfType([PropTypes.instanceOf(Event), PropTypes.object]),
    computedEl: PropTypes.object,
    eventContent: PropTypes.oneOfType([
      PropTypes.bool,
      PropTypes.string
    ]),
    isNewEvent: PropTypes.bool.isRequired,
    onCancel: PropTypes.func,
    onChangeLimit: PropTypes.func,
    onChangeTextContent: PropTypes.func,
    onChangeName: PropTypes.func,
    onChangeSelector: PropTypes.func,
    onDeleteEvent: PropTypes.func,
    onPageScopeChange: PropTypes.func,
    onResetSelector: PropTypes.func,
    onSave: PropTypes.func,
    onSelectionTypeChange: PropTypes.func,
    onUpdatePageview: PropTypes.func,
    mobileVersion: PropTypes.bool,
    originEditedEvent: PropTypes.object
  };

  constructor (...args) {
    super(...args);
    this.state = {...defaultState};
    this.getStatesWithThrottle = _.throttle(this.getStatesWithThrottle, 2000);
  };

  componentDidMount () {
    const {event, eventContent} = this.props;
    this.setState({event, eventContent});
  }

  getContextExtra = () => {
    const extra = contextService.get('extra');
    if (extra && extra.url) {
      const url = new URL(extra.url);
      return {
        input: {
          url: url,
          name: extra.title
        }
      };
    }
    return null;
  }

  componentDidUpdate () {
    wrapFocusIn(this.props.editorState.mode);
  }

  componentWillReceiveProps (nextProps) {
    // do not scroll to avoid flickering
    // only scrll if the there's a new event
    let isSameEvent = this.isSameEvent(nextProps.event);
    if (!isSameEvent) {
      // initialize the state
      let state = {...defaultState};
      if (nextProps.event) {
        state.scroll = true;
      }
      this.setState({...state, loading: false});
    }
    // if (nextProps.event) {
    //   // if (!_.isEqual(nextProps.event, this.props.event)) {
    //   if (!isSameEvent ||
    //     (nextProps.event.attrs.scope !== this.props.event.attrs.scope ||
    //       nextProps.event.attrs.definitionType !== this.props.event.attrs.definitionType ||
    //       nextProps.eventContent !== this.props.eventContent ||
    //       nextProps.event.attrs.content !== this.props.event.attrs.content)) {
    //     this.getStats(nextProps.event, nextProps.eventContent);
    //   }
    // }
  }

  shouldComponentUpdate (nextProps, nextState) {
    if (nextProps.event !== this.props.event ||
        nextProps.editorState.mode !== this.props.editorState.mode ||
        nextState !== this.state ||
        nextProps.eventContent !== this.props.eventContent) {
      return true;
    }
    return false;
  }

  onPageScopeChange = (scope) => {
    const { event, eventContent } = this.props;
    this.setState({restrictToUrl: scope === PAGE_TYPE.SINGLE, changed: true, event, eventContent});
    setTimeout(() => {
      this.props.onPageScopeChange(scope);
    }, 100);
  }

  handleSelectionTypeChange = (type) => {
    const {event, eventContent} = this.props;
    this.setState({ changed: true, event, eventContent });
    this.props.onSelectionTypeChange(type);
  }

  getStatesWithThrottle = (input, operator) => {
    const {event, eventContent} = this.props;
    const content = beautifyPageviewOperators(input, operator);
    event.attrs.pathCondition = content;
    this.getStats(event, eventContent);
  }

  onPathConditionChange = (input, operator, throttle) => {
    this.props.onUpdatePageview(input, operator);
    const {event, eventContent} = this.props;
    const content = beautifyPageviewOperators(input, operator);
    event.attrs.pathCondition = content;
    this.setState({ changed: true, event, eventContent });
  };

  handleRefreshCall = () => {
    this.getStats(this.props.event, this.props.eventContent);
  }

  render () {
    const { mobileVersion } = this.props;
    if (!this.props.event) {
      return null;
    }
    if (this.props.editorState.mode === MODE.BROWSE) {
      return null;
    }

    let {originalElement, originalRect} = this.props.event;
    let numElementsMessage = `${this.props.event.elements.length} element(s) selected`;
    let buttonLabel = this.props.isNewEvent ? 'Define Event' : 'Update Event';
    const isCRUD = this.props.editorState.crudLoading || this.state.saving;
    if (isCRUD === true) {
      buttonLabel = 'Loading...';
    }
    const { loading, stats, changed } = this.state;
    let { events, total } = stats;
    let restrict = PAGE_TYPE.ALL;
    restrict = this.props.event.restrictToUrl ? PAGE_TYPE.SINGLE : PAGE_TYPE.ALL;
    // if (typeof this.state.restrictToUrl === 'undefined') {
    //   restrict = this.props.event.restrictToUrl ? PAGE_TYPE.SINGLE : PAGE_TYPE.ALL;
    // } else {
    //   restrict = this.state.restrictToUrl ? PAGE_TYPE.SINGLE : PAGE_TYPE.ALL;
    // }
    let valid = this.props.event.valid;
    const textContent = this.props.event.attrs.tempEventContent || this.props.event.attrs.eventContent;
    const isDefaultState = this.checkIsDefaultState();
    let showConversionContribution = (!loading && stats.hasOwnProperty('totalrevenue') &&
      stats.totalrevenue >= 0 && stats.overallconversionrate >= 0 &&
      stats.eventconversionrate >= 0 && !isDefaultState);
    let clicksContainerStyle = {padding: '12px', border: '1px solid rgba(223, 228, 236, 1)', borderRadius: '4px',
    marginLeft: '8px', minHeight: '110px'};
    let contributionChartStyle = {display: 'flex', justifyContent: 'space-between', alignItems: 'center',
    paddingRight: '10px'};
    if (!showConversionContribution) {
      delete clicksContainerStyle.marginLeft;
    }
    if (mobileVersion) {
      clicksContainerStyle['marginLeft'] = 0;
      contributionChartStyle['paddingRight'] = 0;
    }

    const trackOnOptions = [
      {
        label: 'All Pages',
        value: 0
      },
      {
        label: 'Specific Pages',
        value: 1
      }
    ];
    const selectionTypeOptions = [
      {
        label: 'Specific Elements',
        value: 0
      },
      {
        label: 'Similar Elements',
        value: 1
      },
      {
        label: 'Manual',
        value: 2
      }
    ];
    const selectedTrackOption = (restrict === PAGE_TYPE.ALL) ? 0 : 1;
    let selectedSelectionType = 0;
    switch (this.props.event.selectionType) {
      case SELECTION_TYPE.SINGLE:
        selectedSelectionType = 0;
        break;
      case SELECTION_TYPE.SIMILAR:
        selectedSelectionType = 1;
        break;
      case SELECTION_TYPE.MANUAL:
        selectedSelectionType = 2;
        break;
      default:
        break;
    }
    let pathCondition = this.props.event.attrs.pathCondition;
    const contentExtra = this.getContextExtra();
    if (pathCondition && contentExtra) {
      try {
        const url = new URL(pathCondition);
        if (url) {
          pathCondition = contentExtra;
        }
      } catch (error) {}
    }
    return (
      <Popup
        className={styles.popup}
        mobileVersion={mobileVersion}
        onClose={this.handleClose}
        targetElement={originalElement}
        targetElementRect={originalRect}>
        <div className={styles.body}>
          <div className={styles.title}>Define Event</div>
          {
            isDefaultState && !loading &&
              <div className={styles.preview}>
                <button
                  className={styles.previewButton}
                  onClick={this.handleRefreshCall}>
                    Preview Event Metric
                </button>
              </div>
          }
          {
            loading &&
              <div className={styles.loader}>
                <Loader/>
              </div>
          }
          <div className={classNames(styles.metricsContainer, {[styles.metricMobile]: mobileVersion})}>
          {
            showConversionContribution &&
              <div className={classNames(styles.insightContainer, {[styles.insightMobile]: mobileVersion})}>
                <div className={classNames(
                  styles.chartTitleCon,
                  {[styles.mobileChart]: mobileVersion}
                  )}
                >
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div className={styles.label} style={{marginRight: '12px !important'}}>Conversion Contribution</div>
                    {/* {changed &&
                      (stats.hasOwnProperty('totalrevenue') === false ||
                      (stats.hasOwnProperty('totalrevenue') && stats.totalrevenue === -1)) &&
                      <button
                        className={styles.refreshButton}
                        onClick={this.handleRefreshCall}>Click to Update
                      </button>} */}
                  </div>
                  <span>Last 7 days</span>
                </div>
                <EventInsight
                  mobileVersion={mobileVersion}
                  type={'Clicked'}
                  {...stats}
                />
              </div>
          }
          {
            !loading && !isDefaultState &&
              <div className={classNames(
                styles.chart,
                {[styles.insightMobile]: mobileVersion},
                {[styles.fullWidth]: !showConversionContribution})}>
                <div className={classNames(
                  styles.chartTitle,
                  {[styles.noMarginLeft]: !showConversionContribution},
                  {[styles.mobileChart]: mobileVersion}
                  )}
                >
                  <div style={{display: 'flex', alignItems: 'center'}}>
                    <div className={styles.label} style={{marginRight: '12px !important'}}>Number of Clicks</div>
                    {/* {changed &&
                      (stats.hasOwnProperty('totalrevenue') === false ||
                      (stats.hasOwnProperty('totalrevenue') && stats.totalrevenue === -1)) &&
                      <button
                        className={styles.refreshButton}
                        onClick={this.handleRefreshCall}>Click to Update
                      </button>} */}
                  </div>
                  <span>Last 7 days</span>
                </div>
                <div style={clicksContainerStyle}>
                  <div className={styles.clickGraphContainer}>
                    <span className={styles.count}>{`${prettifyNumber(total.clicks)} `}</span>
                    <ChartContainer width={170} height={30} data={events} dataKey='clicks'/>
                  </div>
                  <div className={styles.clickGraphContainer}
                    style={{marginTop: '13px'}}>
                    <span>{'Unique Users'}</span>
                    <span className={styles.bold}>{`${prettifyNumber(total.users)} `}</span>
                  </div>
                  <div className={styles.clickGraphContainer}
                    style={{marginTop: '4px'}}>
                    <span>{'% of Total Users'}</span>
                    <span className={styles.bold}>
                      {stats.totalusers ? `${((total.users / stats.totalusers) * 100).toFixed(2)}%` : 0}
                    </span>
                  </div>
                </div>
              </div>
          }
          </div>
          {changed && !isDefaultState &&
            <button
              className={styles.refreshButton}
              onClick={this.handleRefreshCall}>Definition has changed. Click here to refresh metrics.
            </button>
          }
          <div
            className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}
            style={{
              justifyContent: 'space-between',
              margin: 0,
              alignItems: 'center'}}>
            <div className={styles.label} style={{
              fontSize: '14px !important',
              marginRight: '0px !important'}}>Event Name</div>
            <div
              style={{width: '72.6%'}}>
              <InputText
                ref='eventName'
                className={styles.input}
                data-valid={this.state.errorMsg === ''}
                maxLength={EVENT_NAME_MAX_LENGTH}
                onBlur={this.handleNameInputBlur}
                onChange={this.props.onChangeName}
                placeholder='e.g. Checkout'
                value={this.props.event.name}/>
                {
                  this.state.errorMsg &&
                    <div className={styles.error}>{this.state.errorMsg}</div>
                }
            </div>
          </div>
          <div className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}>
            <div className={styles.label}>Track On</div>
            <div style={{display: 'flex', flexDirection: 'column', width: '72%'}}>
              <TabBar
                options={trackOnOptions}
                selected={selectedTrackOption}
                onSelectOption={this.handleTrackTabClick}
              />
            </div>
          </div>
          {
            restrict === 'single' &&
              <div className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}>
                <PageSelection
                  mobileVersion={mobileVersion}
                  pageview={pathCondition || contentExtra || []}
                  onUpdatePageview={this.props.onUpdatePageview}
                  onPathConditionChange={this.onPathConditionChange}
                />
              </div>
          }
          <div className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}>
            <div>
              <div className={styles.label} style={{marginRight: '43px !important'}}>Selection Type</div>
              <div style={{fontSize: '10px !important'}}>{numElementsMessage}</div>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', width: '72%' }}>
              <TabBar
                options={selectionTypeOptions}
                selected={selectedSelectionType}
                onSelectOption={this.handleSelectionTypeTabClick}
              />
            </div>
          </div>
          <div className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}>
            <CssSelectorEditor
              event={this.props.event}
              originEditedEvent={this.props.originEditedEvent}
              disabled={!this.props.isNewEvent && !configSvc.isEditEnabled()}
              onChange={this.props.onChangeSelector}
              onReset={this.props.onResetSelector}
            />
          </div>
          {['SINGLE', 'SIMILAR'].includes(this.props.event.selectionType) &&
            <div className={classNames(styles.section, {[styles.mobileView]: mobileVersion})}>
              <div className={styles.numMessage}>
                <div className={styles.limitTo}>
                  <CheckBox type='checkbox'
                    checked={!!this.props.eventContent}
                    disabled={!this.props.isNewEvent && !configSvc.isEditEnabled()}
                    onChange={this.handleLimitCheckbox}/>
                    Limit to text:
                  <div className={styles.wrapper} title={this.props.event.attrs.eventContent}
                    style={{ width: '80%' }}>
                    {
                      <InputText
                        disabled={!configSvc.isEditEnabled() || !this.props.eventContent}
                        placeholder={'Text in Element'}
                        onChange={this.props.onChangeTextContent}
                        value={textContent}
                      />
                    }
                  </div>
                </div>
              </div>
            </div>
          }
          <div className={styles.buttons}>
            {
              !this.props.isNewEvent &&
                <Button className={styles.button_delete} onClick={this.props.onDeleteEvent(this.props.event)}>
                  Delete Event
                </Button>
            }
            {this.props.isNewEvent && <div></div>}
            <Button className={styles.button} disabled={!valid || isCRUD} onClick={this.handleSave}>
              {buttonLabel}
            </Button>
          </div>
        </div>
      </Popup>
    );
  };

  handleTrackTabClick = (option) => {
    let pageOptions = [
      {onClick: () => this.onPageScopeChange(PAGE_TYPE.ALL)},
      {onClick: () => this.onPageScopeChange(PAGE_TYPE.SINGLE)}
    ];
    pageOptions[option.value].onClick();
  }

  handleSelectionTypeTabClick = (option) => {
    let selectionOptions = [
      {onClick: () => { this.handleSelectionTypeChange(SELECTION_TYPE.SINGLE); }},
      {onClick: () => { this.handleSelectionTypeChange(SELECTION_TYPE.SIMILAR); }},
      {onClick: () => { this.handleSelectionTypeChange(SELECTION_TYPE.MANUAL); }}
    ];
    selectionOptions[option.value].onClick();
  }

  handleLimitCheckbox = (e) => {
    this.setState({changed: true});
    this.props.onChangeLimit(e);
  }

  handleClose = () => {
    this.setState({...this.state, errorMsg: ''});
    this.props.onCancel();
  }

  handleNameInputBlur = () => {
    let event = this.props.event;
    event.name = event.name.trim();
    setTimeout(
      () => {
        if (this.props.event === event) {
          // if the event (i.e. not saved), show error message
          this.validate(this.props.event);
        }
      }, 500);
  };

  handleSave = async () => {
    let event = this.props.event;
    if (await this.validate(event)) {
      this.props.onSave();
    }
  };

  checkIsDefaultState = () => {
    if (_.isEqual(this.state.stats, defaultStats)) {
      return true;
    }
    return false;
  }

  getStats (event, updateEventContent = false) {
    let endDate = new Date();
    endDate.setHours(23, 59, 59, 999);
    let startDate = new Date();
    startDate.setDate(endDate.getDate()-6);
    startDate.setHours(0, 0, 0, 0);

    let params = {
      projectId: event.attrs.projectId,
      currentContextPath: event.attrs.currentContextPath,
      scope: event.attrs.scope,
      beginTime: startDate.getTime(),
      endTime: endDate.getTime(),
      timeZone: contextService.get('timeZone'),
      definitionType: event.attrs.definitionType,
      library: 'Web',
      eventType: event.attrs.eventType
    };
    params.serialized = event.serialized;
    params.content = event.cssSelector;
    if (updateEventContent) {
      params.eventContent = event.attrs.tempEventContent || event.attrs.eventContent;
    }

    if (event.attrs.pathCondition) {
      params.pathCondition = JSON.stringify(event.attrs.pathCondition);
    }
    (async () => {
      this.setState({ loading: true, changed: false });
      let stats = await eventGroupSvc.getStats(params) || defaultStats;
      if (!stats.events || stats.events.length === 0) {
        stats = defaultStats;
      }
      this.setState({ stats }, () => this.setState({ loading: false, changed: this.state.changed }));
    })();
  };

  scrollIntoView () {
    if (!this.state.scroll) {
      return Promise.resove();
    }

    const ANIMATION_MILLIS = 500;
    const INTERVAL_MILLIS = 100;
    const modal = document.querySelector(`.${styles.popup}`);
    const elementRect = modal.getBoundingClientRect();
    const distanceToX = elementRect.left - (window.innerWidth / 2);
    const distanceToY = elementRect.top - (window.innerHeight / 2) + HEADER_HEIGHT;
    if (Math.abs(distanceToY) < 50) { // don't scroll if it's only 50 pixels up or down
      return Promise.resolve();
    } else {
      const frames = ANIMATION_MILLIS / INTERVAL_MILLIS;
      let curScrollX = window.scrollX || window.pageXOffset;
      let curScrollY = window.scrollY || window.pageYOffset;
      let framesExecuted = 0;
      return new Promise((resolve) => {
        const interval = setInterval(function () {
          curScrollX += distanceToX / frames;
          curScrollY += distanceToY / frames;
          curScrollX = curScrollX < 0 ? 0 : curScrollX;
          curScrollY = curScrollY < 0 ? 0 : curScrollY;
          if (framesExecuted < frames) {
            window.scrollTo(curScrollX, curScrollY);
            framesExecuted++;
          } else {
            clearInterval(interval);
            resolve();
          }
        }, INTERVAL_MILLIS);
      });
    }
  };

  async validate (event) {
    let valid = true;
    if (!event) {
      this.setState({...this.state, errorMsg: ''});
      return valid;
    }

    this.setState({saving: true});
    if (this.refs.eventName.refs.input.value.trim() === '') {
      valid = false;
      this.setState({...this.state, saving: false, errorMsg: 'Please provide a name.'});
    } else if (await hasEventNameTaken(event.name, event.id)) {
      valid = false;
      this.setState({...this.state, saving: false, errorMsg: 'Event name must be unique.'});
    } else {
      this.setState({...this.state, saving: false, errorMsg: ''});
    }

    return valid;
  }

  isSameEvent (event) {
    let currentEvent = this.props.event;
    if ((event === null && currentEvent === null) ||
        (event !== null && currentEvent !== null && (event.id === currentEvent.id))) {
      return true;
    }
    return false;
  }
}

async function hasEventNameTaken (name, id) {
  let response = await eventGroupSvc.getEventGroupByName({ name });
  if (response.ok) {
    if (response.json.data.id !== id) {
      return true;
    }
  }
  return false;
}



/** WEBPACK FOOTER **
 ** ./src/views/EventEditor.js
 **/